import { render, staticRenderFns } from "./PostageBulkPricesList.vue?vue&type=template&id=75ef933d&scoped=true"
import script from "./PostageBulkPricesList.vue?vue&type=script&lang=ts"
export * from "./PostageBulkPricesList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75ef933d",
  null
  
)

export default component.exports